import { generateAboutURL } from "../../../src/services/url";
import { CURRENCY, LOGO_URL, EVENT_HANDLERS, LOCATION } from "../../constants";
import { createQueryString } from "./utils";

export const LogoOnly = ({
  merchantId = "",
  currency = CURRENCY.AUD,
  containerClass = "",
  price,
  paymentOption,
  promotionMonths,
  productName,
  allowPriceBreakdown,
}) => {
  const aboutURL = generateAboutURL(
    merchantId,
    currency,
    createQueryString(
      paymentOption,
      price,
      promotionMonths,
      allowPriceBreakdown,
      productName,
      LOCATION.WIDGET
    )
  );
  const logoURL = LOGO_URL[currency];

  return `
  <!-- Latitude Interest Free Snippet - Start -->
  <span>
    <a 
      id="lat-find-out"
      target="_blank"
      onclick="${EVENT_HANDLERS.LEARN_MORE_CLICK}('${aboutURL}')"
      style="display:inline-block; padding: 10px 0; text-decoration:underline; font-weight:bold; font-size:12px; cursor:pointer; color:inherit;"
    >
    <img
    style="${currency === "AUD" ? `height:22px;` : `height:28px;`}"
    src="${logoURL}"
    alt="logo-${currency}"
  />
    </a>
  </span>
  <!-- Latitude Interest Free Snippet - End -->
  `;
};
